import { render } from "./intangibleOfflinePage.vue?vue&type=template&id=86b57766&scoped=true"
import script from "./intangibleOfflinePage.vue?vue&type=script&lang=js"
export * from "./intangibleOfflinePage.vue?vue&type=script&lang=js"

import "./intangibleOfflinePage.vue?vue&type=style&index=0&id=86b57766&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b57766"]])

export default __exports__